/* eslint-disable no-nested-ternary */
import { Button, Chip, Grid, Paper } from '@material-ui/core';
import {
  Business,
  CalendarToday as CalendarTodayIcon,
  InsertDriveFile as InsertDriveFileIcon,
  InsertInvitation,
  Person,
  Person as PersonIcon,
  Send,
} from '@material-ui/icons';
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import {
  getDocuments,
  getInfoStudentDocument,
  getInfosBusiness,
  getInfosIndividual,
  getInfosSchool,
} from '@webapps/business';
import {
  PaginationNumbers,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  useAuth,
  useMutation,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { getFileURLPDF } from '@webapps/utils';

import ModalFullScreenWithoutAction from 'components/ModalFullScreenWithoutAction/ModalFullScreenWithoutAction';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import theme from '../TeamsPages/Team/theme';

const {
  colors: { itemColor },
} = theme;

const BusinessDocuments = () => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const [page, setPage] = useState(1);

  // FRONT END RESTRICTIONS => Redirect to dashboard if free Account
  const { checkPermissions, isPremium } = useAuth();

  useEffect(() => {
    if (isPremium !== null) {
      checkPermissions();
    }
  }, [isPremium]);

  const {
    // status: load,
    data: { content: documents = [], totalElements } = {},
    // refetch: refetchDocuments,
    // isFetching,
  } = useQuery(getDocuments, {
    key: ['documentsStudent', page + idUser],
    variables: {
      id: idUser,
      page: page - 1,
      size: 16,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const [viewAchievement, setViewAchievement] = useState(false);
  const [path, setPath] = useState('');

  const handleOpenViewAchievement = () => {
    setViewAchievement(true);
  };
  const handleCloseViewAchievement = () => {
    setViewAchievement(false);
  };

  const {
    data: dataAttachment,
    // isLoading: isLoadingInfoAttachment,
    isSuccess: isSuccessInfoAttachment,
    mutateAsync: mutateInfoAttachment,
  } = useMutation(getInfoStudentDocument);

  const getPathLink = (id) => {
    mutateInfoAttachment({
      id,
    });
  };

  useEffect(() => {
    if (isSuccessInfoAttachment) {
      setPath('');
      getFileURLPDF(dataAttachment?.path, setPath);
      handleOpenViewAchievement();
    }
  }, [isSuccessInfoAttachment]);

  if (!isPremium) {
    return <div></div>;
  }

  const getText = (type, issuer) => {
    if (type === 'ACHIEVEMENT') return 'Importé';
    if (type === 'CONTRACT') return 'Reçu';
    if (type === "EDU-PRO-CONNECT") return 'Reçu';
    if (type === 'AFFILIATE_ATTACHMENT') {
      if (issuer === 'STUDENT' || issuer === 'SCHOOL') return 'Reçu';
      if (issuer === 'BUSINESS') return 'Emis';
    }
    return 'Non renseigné';
  };

  return (
    <div className={classes.container}>
      <div className={classes.paper}>
        <Grid
          container
          style={
            documents.length === 0
              ? {
                  display: 'flex',
                  justifyContent: 'center',
                  padding: spacing(2.5),
                  backgroundColor: '#F3F7FF',
                  borderRadius: 10,
                }
              : {
                  display: 'flex',
                  backgroundColor: '#F3F7FF',
                  borderRadius: 10,
                  padding: spacing(2.5, 0, 0, 2.5),
                }
          }
        >
          {!documents?.length ? (
            <div
              className={css({
                textAlign: 'center',
                color: '#5D75A8',
              })}
            >
              <FormattedMessage id="noElements" />
            </div>
          ) : (
            <Grid container>
              {documents.map(
                ({ type, id, issuer, issuerId, name, createdAt }, index) => (
                  <Grid item xs={12} md={4} lg={3} >
                    <div style={{ padding: spacing(0, 2.5, 2.5, 0) }}>
                      <div
                        style={{
                          padding: 20,
                          borderRadius: 10,
                          backgroundColor: '#FFF',
                        }}
                        key={index}
                      >
                        <div style={{ marginBottom: spacing(2.5) }} className={global.title}> {name} </div>
                        <div className={cx(classes.address, global.infoText)}>
                          <Send className={global.infoIcon} />
                          <div>{getText(type, issuer)}</div>
                        </div>
                        <GetUser id={issuerId} type={issuer} />
                        <div className={cx(classes.address, global.infoText)}>
                          <InsertInvitation className={global.infoIcon} />
                          <div>
                            <FormattedDate
                              day="numeric"
                              month="long"
                              value={new Date(createdAt)}
                              year="numeric"
                            />
                          </div>
                        </div>
                        <div className={classes.buttons}>
                          <Button
                            variant="outlined"
                            fullWidth
                            onClick={() => getPathLink(id)}
                          >
                            Voir le document
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Grid>
                )
              )}
            </Grid>
          )}
        </Grid>
        <PaginationNumbers
          onChange={handlePaginationChange}
          page={page}
          pageCount={9}
          totalCount={totalElements}
        />
      </div>
      <ModalFullScreenWithoutAction
        onCancel={handleCloseViewAchievement}
        open={viewAchievement}
        title="Mes documents"
      >
        <iframe
          className={css({ width: '100%', height: '100%' })}
          frameBorder="0"
          src={path}
          title="Fichier"
        />
      </ModalFullScreenWithoutAction>
    </div>
  );
};

const GetUser = ({ id, type }) => {
  const {
    css,
    classes,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { data: info = {} } = useQuery(getInfosIndividual, {
    key: ['indivudualInfos', id],
    variables: { id },
    enabled: type === 'STUDENT',
  });

  const { data: infosSchool = {} } = useQuery(getInfosSchool, {
    key: 'schoolInfos' + id,
    variables: { id },
    enabled: type === 'SCHOOL',
  });

  // const { data: infosBusiness = {} } = useQuery(getInfosBusiness, {
  //   key: 'businessInfos',
  //   variables: { id },
  //   enabled: type === 'BUSINESS',
  // });

  
  return id && type ? (
    <div className={cx(classes.address, global.infoText)}>
      {type === 'BUSINESS' ? (
        <>
          <Business className={global.infoIcon} />
          <div>{'de vous'}</div>
        </>
      ) : type === 'SCHOOL' ? (
        <>
          <Business className={global.infoIcon} />
          <div>{'De ' + infosSchool?.name}</div>
        </>
      ) : (
        <>
          <Person className={global.infoIcon} />
          <div>
            {info?.firstname + ' ' + info?.lastname}
          </div>
        </>
      )}
    </div>
  ) : (
    <div className={cx(classes.address, global.infoText)}>
      <Business className={global.infoIcon} />
      <div>{'non renseigné'}</div>
    </div>
  );
};

GetUser.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
};

const styles = ({ spacing }) => ({
  container: {
    minHeight: '90vh',
        padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    fontWeight: 600,
    color: '#152652',
    lineHeight: '110%',
    '@media only screen and (max-width:768px)': { padding: '20px' },
  },
  paper: {
    padding: spacing(2.5),
    flex: '1 1 0px',
    borderRadius: 10,
    background: 'white',
    '@media only screen and (max-width:768px)': { marginTop: spacing(3) },
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacing(2),
  },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: spacing(2),
  },
  address: {
    marginTop: spacing(0.5),
    display: 'flex',
    alignItems: 'center',
  },
});

export default BusinessDocuments;
